import React from 'react';

import { mosaiqStyled } from '../../lib';
import { DividerProps } from './types';
import { DividerWrapper, VerticalDividerWrapper } from './Divider.styles';

const Divider = mosaiqStyled<DividerProps>(({ color, vertical, ...props }) => {
  const Wrapper = vertical ? VerticalDividerWrapper : DividerWrapper;
  return <Wrapper $color={color} {...props} />;
});

export default Divider;
